module.exports = __webpack_public_path__ + "static/media/Zamzama-Kim-c1960.0cd58d99.jpg";